import {
    ORDER_PARTS,
} from '@app/react/const/variables';

export const r2o = (
    route: string | null | undefined,
): typeof ORDER_PARTS[number] | 'preview' | null => {
    switch (route) {
        case 'shaft':
            return route;
        case 'hane':
            return 'feather';
        case 'washi':
            return 'thread';
        case 'kebiki':
            return route;
        case 'hazu':
            return 'nock';
        case 'yajiri':
            return 'arrowhead';
        case 'yashaku':
            return 'arrowlength';
        case 'honsu':
            return 'unit';
        case 'insert':
            return 'arrowinsert';
        case 'hazumaki':
            return 'twine';
        case 'rame':
            return 'lame';
        case 'kokuin':
            return 'carving';
        case 'kamon':
            return 'familycrest';
        case 'typezero':
            return route;
        case 'deco':
            return 'decoration';
        case 'featherinside':
            return route;
        case 'preview':
            return route;
        default:
            return null;
    }
};
